// navbar hook

export default {
    mounted () {
        
    }
}